  (function() {
  const searchInput = document.getElementById('joeba-search-input');
  const searchClear = document.getElementById('joeba-search-clear');
  const searchSuggestions = document.getElementById('joeba-search-suggestions');
  const resultsCount = document.getElementById('joeba-search-results-count');
  const noResults = document.getElementById('joeba-no-results');
  const sections = document.querySelectorAll('.joeba-blog-city');
  const alphaBtns = document.querySelectorAll('.joeba-collections-filter .alpha-btn');
  const toolbar = document.getElementById('joeba-az-toolbar');
  const toolbarHeight = toolbar ? toolbar.offsetHeight + 20 : 0;
  if (!searchInput || !sections.length) return;
  const allCities = [];
  sections.forEach(section => {
  const title = section.querySelector('.joeba-blog-city__title');
  if (title) {
  allCities.push({
  name: title.textContent.trim(),
  section: section
  });
  }
  });
  function showSearchSuggestions(query) {
  if (!searchSuggestions || query.length < 1) {
  if (searchSuggestions) searchSuggestions.classList.remove('is-visible');
  return;
  }
  const filtered = allCities.filter(city =>
  city.name.toLowerCase().includes(query.toLowerCase())
  ).slice(0, 8);
  if (filtered.length > 0) {
  searchSuggestions.innerHTML = filtered.map(city =>
  `<button type="button" class="joeba-search-suggestion" data-city="${city.name}">${city.name}</button>`
  ).join('');
  searchSuggestions.classList.add('is-visible');
  } else {
  searchSuggestions.classList.remove('is-visible');
  }
  }
  function jumpToSection(cityName) {
  const city = allCities.find(c => c.name === cityName);
  if (city && city.section) {
  sections.forEach(s => s.style.display = '');
  const y = city.section.getBoundingClientRect().top + window.pageYOffset - toolbarHeight - 10;
  window.scrollTo({ top: y, behavior: 'smooth' });
  searchInput.value = cityName;
  if (searchSuggestions) searchSuggestions.classList.remove('is-visible');
  if (searchClear) searchClear.classList.add('is-visible');
  alphaBtns.forEach(btn => {
  btn.classList.remove('is-active');
  if (btn.getAttribute('data-letter') === '*') {
  btn.classList.add('is-active');
  }
  });
  }
  }
  function performSearch(query) {
  const searchTerm = query.toLowerCase().trim();
  let visibleCount = 0;
  if (searchClear) {
  searchClear.classList.toggle('is-visible', searchTerm.length > 0);
  }
  if (searchTerm.length > 0) {
  alphaBtns.forEach(btn => {
  btn.classList.remove('is-active');
  if (btn.getAttribute('data-letter') === '*') {
  btn.classList.add('is-active');
  }
  });
  }
  sections.forEach(section => {
  const title = section.querySelector('.joeba-blog-city__title');
  const cityName = title ? title.textContent.toLowerCase() : '';
  if (searchTerm === '' || cityName.includes(searchTerm)) {
  section.style.display = '';
  visibleCount++;
  } else {
  section.style.display = 'none';
  }
  });
  if (resultsCount) {
  if (searchTerm.length > 0) {
  resultsCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'stad' : 'steden'} gevonden`;
  resultsCount.classList.add('is-visible');
  } else {
  resultsCount.classList.remove('is-visible');
  }
  }
  if (noResults) {
  noResults.classList.toggle('is-visible', searchTerm.length > 0 && visibleCount === 0);
  }
  updateLetterAvailability();
  }
  function updateLetterAvailability() {
  const visibleSections = document.querySelectorAll('.joeba-blog-city:not([style*="display: none"])');
  const availableLetters = new Set();
  visibleSections.forEach(section => {
  const letter = (section.dataset.letter || '').toUpperCase();
  if (letter && letter !== 'PREMIUM') {
  availableLetters.add(letter);
  }
  });
  alphaBtns.forEach(btn => {
  const letter = btn.getAttribute('data-letter');
  if (letter && letter !== '*') {
  btn.classList.toggle('is-disabled', !availableLetters.has(letter));
  }
  });
  }
  searchInput.addEventListener('input', (e) => {
  const query = e.target.value;
  showSearchSuggestions(query);
  clearTimeout(searchInput._debounce);
  searchInput._debounce = setTimeout(() => {
  performSearch(query);
  }, 300);
  });
  searchInput.addEventListener('focus', () => {
  if (searchInput.value.length > 0) {
  showSearchSuggestions(searchInput.value);
  }
  });
  if (searchSuggestions) {
  searchSuggestions.addEventListener('click', (e) => {
  const btn = e.target.closest('.joeba-search-suggestion');
  if (btn) {
  jumpToSection(btn.dataset.city);
  }
  });
  }
  searchInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
  e.preventDefault();
  const firstSuggestion = searchSuggestions?.querySelector('.joeba-search-suggestion');
  if (firstSuggestion) {
  jumpToSection(firstSuggestion.dataset.city);
  }
  }
  });
  document.addEventListener('click', (e) => {
  if (!e.target.closest('.joeba-search-wrapper')) {
  if (searchSuggestions) searchSuggestions.classList.remove('is-visible');
  }
  });
  if (searchClear) {
  searchClear.addEventListener('click', () => {
  searchInput.value = '';
  performSearch('');
  if (searchSuggestions) searchSuggestions.classList.remove('is-visible');
  searchInput.focus();
  });
  }
  updateLetterAvailability();
  })();
  (function() {
  const toolbar = document.getElementById('joeba-az-toolbar');
  const filterContainer = document.querySelector('.joeba-filter-container');
  if (!toolbar || !filterContainer) return;
  const observer = new IntersectionObserver(
  ([entry]) => {
  toolbar.classList.toggle('is-sticky', !entry.isIntersecting);
  },
  {
  threshold: 0,
  rootMargin: '-1px 0px 0px 0px'
  }
  );
  observer.observe(filterContainer);
  })();
  (function() {
  const alphaBtns = document.querySelectorAll('.joeba-collections-filter .alpha-btn');
  const sections  = document.querySelectorAll('.joeba-blog-city');
  if (!alphaBtns.length || !sections.length) return;
  const topEl = document.getElementById('joeba-blog-top');
  const toolbar = document.getElementById('joeba-az-toolbar');
  const toolbarHeight = toolbar ? toolbar.offsetHeight + 20 : 0;
  alphaBtns.forEach(btn => {
  btn.addEventListener('click', () => {
  if (btn.classList.contains('is-disabled')) return;
  alphaBtns.forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');
  const letter = btn.getAttribute('data-letter');
  if (!letter || letter === '*') {
  const searchInput = document.getElementById('joeba-search-input');
  if (searchInput) {
  searchInput.value = '';
  searchInput.dispatchEvent(new Event('input'));
  }
  var rail0 = document.querySelector('.joeba-blog-by-city[data-jb-hrail]');
  if (rail0) rail0.scrollTo({ left: 0, behavior: 'smooth' });
  if (topEl) {
  topEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  return;
  }
  const rail = document.querySelector('.joeba-blog-by-city[data-jb-hrail]');
  const target = Array.from(sections).find(section => {
   return (section.dataset.letter || '').toUpperCase() === letter &&
   section.style.display !== 'none';
   });
   if (target) {
   if (rail && rail.contains(target)) {
   var y = rail.getBoundingClientRect().top + window.pageYOffset - toolbarHeight - 10;
   window.scrollTo({ top: y, behavior: 'smooth' });
   rail.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
   } else {
   var y2 = target.getBoundingClientRect().top + window.pageYOffset - toolbarHeight - 10;
   window.scrollTo({ top: y2, behavior: 'smooth' });
   }
   }
  });
  });
  })();

  (function(){
    function start(){
    if (typeof L === 'undefined') { setTimeout(start, 300); return; }
    var maps = document.querySelectorAll('.joeba-city-map[data-city-map]');
    if (!maps.length) { setTimeout(start, 500); return; }
    var CACHE_KEY = 'joeba_geo_v1';
    var cache = {};
    try { cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}'); } catch(e){}
    function saveCache(){ try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch(e){} }
    function geocode(city, country){
      var key = (city+'|'+country).toLowerCase();
      if (cache[key]) return Promise.resolve(cache[key]);
      var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&q='+encodeURIComponent(city+', '+country);
      return fetch(url, {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(data){
        if (data && data[0]) { cache[key] = {lat:parseFloat(data[0].lat), lon:parseFloat(data[0].lon)}; saveCache(); return cache[key]; }
        return null;
      }).catch(function(){return null;});
    }
    function initMap(el){
      if (el.dataset.jbMapInit) return;
      el.dataset.jbMapInit = '1';
      el.classList.add('is-loading');
      var city = el.getAttribute('data-city-map');
      var country = el.getAttribute('data-country-name') || '';
      geocode(city, country).then(function(coords){
        if (!coords) { el.classList.remove('is-loading'); el.innerHTML = '<div style="padding:18px;text-align:center;color:#64748b;font-size:13px">Kaart niet beschikbaar voor '+city+'</div>'; return; }
        var map = L.map(el, {scrollWheelZoom:false, attributionControl:false, zoomControl:true, dragging:true}).setView([coords.lat, coords.lon], 11);
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png', {subdomains:'abcd', maxZoom:18}).addTo(map);
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png', {subdomains:'abcd', maxZoom:18, opacity:0.9}).addTo(map);
        var icon = L.divIcon({className:'jb-city-pin', html:'<div style="width:30px;height:30px;border-radius:50% 50% 50% 0;background:#FFDE59;border:2px solid #0e1b4d;transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center"><div style="transform:rotate(45deg);font-size:14px">\ud83d\udccd</div></div>', iconSize:[30,30], iconAnchor:[15,28]});
        L.marker([coords.lat, coords.lon], {icon:icon}).addTo(map).bindTooltip(city, {permanent:false, direction:'top', offset:[0,-22]});
        el.classList.remove('is-loading');
        setTimeout(function(){ map.invalidateSize(); }, 200);
      });
    }
    maps.forEach(function(m, i){ setTimeout(function(){ initMap(m); }, i * 1100); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  })();

  (function() {
  const backToTop = document.getElementById('joeba-back-to-top');
  const topEl = document.getElementById('joeba-blog-top');
  function scrollToTop() {
  if (topEl) {
  topEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  }
  if (backToTop) {
  backToTop.addEventListener('click', scrollToTop);
  }
  })();
  (function() {
  var toggle = document.getElementById('joebaContinentToggle');
  var dropdown = document.getElementById('joebaContinentDropdown');
  if (!toggle || !dropdown) return;
  if (window.innerWidth <= 900) document.body.appendChild(dropdown);
  toggle.addEventListener('click', function(e) {
  e.stopPropagation();
  var isOpen = dropdown.classList.toggle('is-visible');
  toggle.classList.toggle('is-open', isOpen);
  if (isOpen && window.innerWidth <= 900) {
  var nav = document.getElementById('joeba-city-nav');
  if (nav) {
  var navRect = nav.getBoundingClientRect();
  dropdown.style.bottom = (window.innerHeight - navRect.top) + 'px';
  }
  }
  });
  document.addEventListener('click', function() {
  dropdown.classList.remove('is-visible');
  toggle.classList.remove('is-open');
  });
  })();
  (function() {
  var countryScroll = document.getElementById('joebaCountryLinks');
  var countryLeft = document.getElementById('joebaCountryNavLeft');
  var countryRight = document.getElementById('joebaCountryNavRight');
  var step = 200;
  if (countryLeft && countryScroll) {
  countryLeft.addEventListener('click', function() {
  countryScroll.scrollBy({ left: -step, behavior: 'smooth' });
  });
  }
  if (countryRight && countryScroll) {
  countryRight.addEventListener('click', function() {
  countryScroll.scrollBy({ left: step, behavior: 'smooth' });
  });
  }
  })();
  (function() {
  var countryLinksEl = document.getElementById('joebaCountryLinks');
  var cityNavScroll = document.getElementById('joebaCityNavScroll');
  var currentBlogHandle = (window.__JB_BLOG_HANDLE || '');
  var currentCityFromPath = (window.__JB_CITY_FROM_PATH || '');
  var continentToggleEl = document.getElementById('joebaContinentToggle');
  var breadcrumbEl = document.getElementById('jbMobBreadcrumb');
  var cityCache = {};
  if (!countryLinksEl || !cityNavScroll) return;
  // Popular cities per land (max 5, vaste volgorde). Spiegelt v3-artikel.
  var POPULAR = (window.__JOEBA_POPULAR_CITIES) || {
    'spanje':['barcelona','madrid','sevilla','valencia','malaga'],
    'italie':['rome','florence','venetie','milaan','napels'],
    'frankrijk':['parijs','nice','marseille','lyon','bordeaux'],
    'portugal':['lissabon','porto','algarve','madeira','azoren'],
    'griekenland':['athene','santorini','mykonos','kreta','rhodos'],
    'kroatie':['dubrovnik','split','hvar','zagreb','pula'],
    'duitsland':['berlijn','munchen','hamburg','keulen','frankfurt'],
    'oostenrijk':['wenen','salzburg','innsbruck','hallstatt','graz'],
    'verenigd-koninkrijk':['londen','edinburgh','manchester','liverpool','york'],
    'ierland':['dublin','galway','cork','killarney','belfast'],
    'nederland':['amsterdam','rotterdam','utrecht','den-haag','maastricht'],
    'belgie':['brussel','brugge','antwerpen','gent','leuven'],
    'turkije':['istanbul','antalya','kappadocie','bodrum','izmir'],
    'thailand':['bangkok','phuket','chiang-mai','koh-samui','krabi'],
    'japan':['tokyo','kyoto','osaka','hiroshima','nara'],
    'vietnam':['hanoi','ho-chi-minh-stad','hoi-an','da-nang','ha-long-bay'],
    'indonesie':['bali','ubud','yogyakarta','jakarta','lombok'],
    'vae':['dubai','abu-dhabi'],
    'india':['delhi','mumbai','jaipur','agra','goa'],
    'vs':['new-york','los-angeles','las-vegas','miami','san-francisco'],
    'mexico':['cancun','playa-del-carmen','tulum','mexico-stad','oaxaca'],
    'canada':['toronto','vancouver','montreal','banff','quebec'],
    'brazilie':['rio-de-janeiro','sao-paulo','salvador','florianopolis'],
    'argentinie':['buenos-aires','bariloche','ushuaia','mendoza'],
    'peru':['cusco','lima'],
    'colombia':['cartagena','medellin','bogota'],
    'australie':['sydney','melbourne','cairns','gold-coast','uluru'],
    'nieuw-zeeland':['queenstown','auckland','wellington','rotorua','christchurch'],
    'zuid-afrika':['kaapstad','krugerpark','johannesburg','durban'],
    'marokko':['marrakech','fes','chefchaouen','casablanca','essaouira'],
    'egypte':['caïro','luxor','hurghada','sharm-el-sheikh']
  };
  window.__JOEBA_POPULAR_CITIES = POPULAR;
  // Smart-reorder van de initial server-rendered city-lijst (huidige land):
  // populaire steden eerst (max 5), rest A-Z, en altijd "Bekijk alle steden →" achteraan.
  (function reorderInitialCityNav(){
    try {
      var handle = (currentBlogHandle || '').toLowerCase();
      if (!handle) return;
      var popular = (POPULAR[handle] || []).slice(0, 5);
      var popularSet = {}; popular.forEach(function(h){ popularSet[h] = true; });
      // Items zijn <span class="joeba-city-nav__group"> wrappers met een <button data-nav-city>.
      var groups = Array.prototype.slice.call(cityNavScroll.querySelectorAll('.joeba-city-nav__group'));
      if (!groups.length) return;
      var byHandle = {};
      var entries = [];
      groups.forEach(function(g){
        var btn = g.querySelector('[data-nav-city]');
        if (!btn) return;
        var h = (btn.getAttribute('data-nav-city') || '').toLowerCase();
        var name = (btn.textContent || '').trim();
        if (name.toLowerCase().indexOf('bekijk alle steden') !== -1) { g.parentNode && g.parentNode.removeChild(g); return; }
        if (popularSet[h]) btn.classList.add('is-popular');
        byHandle[h] = { el: g, name: name };
        entries.push(h);
      });
      var ordered = [];
      popular.forEach(function(h){ if (byHandle[h]) { ordered.push(byHandle[h].el); delete byHandle[h]; } });
      var rest = Object.keys(byHandle).map(function(k){ return byHandle[k]; });
      rest.sort(function(a,b){ return a.name.localeCompare(b.name, 'nl'); });
      ordered = ordered.concat(rest.map(function(r){ return r.el; }));
      ordered.forEach(function(el){ cityNavScroll.appendChild(el); });
      // Append see-all
      var seeAll = document.createElement('a');
      seeAll.href = '/blogs/' + handle;
      seeAll.className = 'joeba-city-nav__link joeba-city-nav__link--see-all';
      seeAll.textContent = 'Bekijk alle steden →';
      cityNavScroll.appendChild(seeAll);
    } catch(e) { /* no-op */ }
  })();
  countryLinksEl.addEventListener('click', function(e) {
  var btn = e.target.closest('.joeba-country-nav-layer__link');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  var handle = btn.dataset.countryHandle;
  var code = btn.dataset.countryCode;
  if (!handle) return;
  countryLinksEl.querySelectorAll('.joeba-country-nav-layer__link').forEach(function(l) { l.classList.remove('is-current'); });
  btn.classList.add('is-current');
  if (breadcrumbEl) {
  breadcrumbEl.dataset.currentBlogHandle = handle;
  breadcrumbEl.dataset.currentCityHandle = '';
  }
  if (handle === currentBlogHandle) {
  restoreLocalCities();
  try {
    var heroEl = document.querySelector('.joeba-country-hero');
    if (heroEl && heroEl.classList.contains('is-city-mode') && typeof window.joebaSwapToLand === 'function') {
      window.joebaSwapToLand();
    } else if (location.hash) {
      history.replaceState(null, '', location.pathname + location.search);
    }
  } catch(_) {}
  return;
  }
  loadCitiesForCountry(handle, code);
  }, true);
  document.querySelectorAll('#joebaContinentDropdown [data-continent]').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
  var continent = btn.getAttribute('data-continent');
  if (!continent) return;
  if (window.innerWidth <= 900) return;
  e.preventDefault();
  /* GEEN stopPropagation: chrome.js heeft een delegated listener op
     #joebaContinentDropdown die het pill-label updatet en automatisch
     doorschakelt naar de Land-popup. */
  var labels = window.__JOEBA_CONTINENT_LABELS || {};
  if (breadcrumbEl) breadcrumbEl.dataset.currentContinent = continent;
  var tn = continentToggleEl && continentToggleEl.childNodes && continentToggleEl.childNodes[0];
  if (tn && tn.nodeType === 3) tn.textContent = (labels[continent] || continent) + ' ';
  document.querySelectorAll('#joebaContinentDropdown [data-continent]').forEach(function(node) {
  node.classList.toggle('is-active', node === btn);
  });
  if (window.innerWidth > 900) {
  var raw = (window.__JOEBA_CONTINENT_COUNTRIES || {})[continent] || '';
  var html = '';
  raw.split(',').forEach(function(cd) {
  var p = cd.split(':');
  if (p.length < 3) return;
  var handle = p[0];
  var code = p[1];
  var name = p[2];
  html += '<button type="button" class="joeba-country-nav-layer__link' + (handle === currentBlogHandle ? ' is-current' : '') + '" data-country-handle="' + handle + '" data-country-code="' + code + '" data-country-name="' + name + '"><img src="https://flagcdn.com/w40/' + code + '.png" alt="" class="joeba-country-nav-layer__flag" loading="lazy">' + name + '</button>';
  });
  if (html) countryLinksEl.innerHTML = html;
  if (!countryLinksEl.querySelector('.joeba-country-nav-layer__link.is-current')) {
  var fixedHost = document.getElementById('joebaCityNavCountryFixed');
  if (fixedHost) fixedHost.innerHTML = '';
  cityNavScroll.innerHTML = '<span style="color:#6b7280;padding:12px 16px;font-size:13px;white-space:nowrap;">Kies een land</span>';
  }
  }
  dropdown.classList.remove('is-visible');
  toggle.classList.remove('is-open');
  });
  });
  var originalCityNavHTML = cityNavScroll.innerHTML;
  function restoreLocalCities() {
  cityNavScroll.innerHTML = originalCityNavHTML;
  bindLocalCityClicks();
  if (breadcrumbEl) breadcrumbEl.dataset.currentBlogHandle = currentBlogHandle;
  if (breadcrumbEl && currentCityFromPath) breadcrumbEl.dataset.currentCityHandle = currentCityFromPath;
  }
  function loadCitiesForCountry(handle, countryCode) {
  if (cityCache[handle]) {
  renderRemoteCities(cityCache[handle], handle, countryCode);
  return;
  }
  cityNavScroll.innerHTML = '<span style="color:#999;padding:12px 16px;font-size:13px;">Steden laden...</span>';
  fetch('/blogs/' + handle)
  .then(function(r) { return r.text(); })
  .then(function(html) {
  var cityData = [];
  var seen = {};
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var heroEls = doc.querySelectorAll('[data-city-handle]');
  heroEls.forEach(function(el) {
  var h = el.getAttribute('data-city-handle');
  if (!h || seen[h]) return;
  var nameEl = el.querySelector('.joeba-city-hero__name');
  var cityName = nameEl ? nameEl.textContent.trim() : '';
  if (!cityName) {
  cityName = h.split('-').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  seen[h] = true;
  cityData.push({ handle: h, name: cityName });
  });
  cityCache[handle] = { cities: cityData, code: countryCode };
  renderRemoteCities(cityCache[handle], handle, countryCode);
  })
  .catch(function() {
  cityNavScroll.innerHTML = '<a href="/blogs/' + handle + '" style="color:#0e1b4d;padding:12px 16px;font-size:13px;text-decoration:underline;">Bekijk alle steden →</a>';
  });
  }
  function renderRemoteCities(data, handle, countryCode) {
  if (!data.cities || data.cities.length === 0) {
  cityNavScroll.innerHTML = '<a href="/blogs/' + handle + '" style="color:#0e1b4d;padding:12px 16px;font-size:13px;text-decoration:underline;">Bekijk land →</a>';
  return;
  }
  var countryBtn = document.querySelector('.joeba-country-nav-layer__link[data-country-handle="' + handle + '"]');
  var countryName = countryBtn ? (countryBtn.textContent || '').trim() : handle.charAt(0).toUpperCase() + handle.slice(1).replace(/-/g, ' ');
  // Country-pill BUITEN de scroller plaatsen (vaste, sticky container).
  var countryPillHtml = '<a href="/blogs/' + handle + '" class="joeba-city-nav__link joeba-city-nav__link--country" aria-label="Bekijk ' + countryName + ' overzicht" title="Bekijk ' + countryName + ' overzicht">' +
    '<img src="https://flagcdn.com/w40/' + countryCode + '.png" alt="" class="joeba-city-nav__flag" loading="lazy">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;margin-right:4px;flex-shrink:0;"><path d="M3 12l2-2 7-7 7 7 2 2"/><path d="M5 10v10h14V10"/></svg>' +
    countryName + '</a>';
  var fixedHost = document.getElementById('joebaCityNavCountryFixed');
  if (!fixedHost) {
    fixedHost = document.createElement('div');
    fixedHost.className = 'joeba-city-nav__country-fixed';
    fixedHost.id = 'joebaCityNavCountryFixed';
    if (cityNavScroll && cityNavScroll.parentNode) {
      cityNavScroll.parentNode.insertBefore(fixedHost, cityNavScroll);
    }
  }
  fixedHost.innerHTML = countryPillHtml;
  // Sorteer: max 5 populaire eerst, dan rest A-Z. Filter "Bekijk alle steden" entries.
  var popular = (POPULAR[handle] || []).slice(0, 5);
  var popularSet = {}; popular.forEach(function(h){ popularSet[h] = true; });
  var byHandle = {};
  data.cities.forEach(function(c){
    var n = (c.name||'').toLowerCase();
    if (n.indexOf('bekijk alle steden') !== -1) return;
    byHandle[c.handle] = c;
  });
  var ordered = [];
  popular.forEach(function(h){ if (byHandle[h]) { ordered.push(byHandle[h]); delete byHandle[h]; } });
  var rest = Object.keys(byHandle).map(function(k){ return byHandle[k]; });
  rest.sort(function(a,b){ return (a.name||'').localeCompare((b.name||''), 'nl'); });
  ordered = ordered.concat(rest);
  var html = '';
  ordered.forEach(function(city) {
    var pop = popularSet[city.handle] ? ' is-popular' : '';
    /* Cross-blog city: render as <a> with href zodat browser-navigatie altijd werkt,
       en zonder data-nav-city zodat de lokale capture-handler 'm niet onderschept. */
    html += '<a href="/blogs/' + handle + '#stad-' + city.handle + '" class="joeba-city-nav__link' + pop + '" data-remote-city="' + city.handle + '" data-target-url="/blogs/' + handle + '#stad-' + city.handle + '">' +
      '<img src="https://flagcdn.com/w40/' + countryCode + '.png" alt="" class="joeba-city-nav__flag" loading="lazy">' +
      city.name + '</a>';
  });
  html += '<a href="/blogs/' + handle + '" class="joeba-city-nav__link joeba-city-nav__link--see-all" data-target-url="/blogs/' + handle + '">Bekijk alle steden →</a>';
  cityNavScroll.innerHTML = html;
  cityNavScroll.querySelectorAll('.joeba-city-nav__link[data-target-url]').forEach(function(link) {
  link.addEventListener('click', function(e) {
  /* Laat browser z'n werk doen via href; voorkom alleen dat andere handlers de event opvreten. */
  e.stopImmediatePropagation();
  e.stopPropagation();
  });
  });
  if (breadcrumbEl) {
  breadcrumbEl.dataset.currentBlogHandle = handle;
  breadcrumbEl.dataset.currentCityHandle = '';
  }
  if (continentToggleEl && countryLinksEl.contains(document.querySelector('.joeba-country-nav-layer__link[data-country-handle="' + handle + '"]'))) {
  var currentContinent = (breadcrumbEl && breadcrumbEl.dataset.currentContinent) || '';
  var labels = window.__JOEBA_CONTINENT_LABELS || {};
  var tn = continentToggleEl.childNodes && continentToggleEl.childNodes[0];
  if (tn && tn.nodeType === 3 && currentContinent) tn.textContent = (labels[currentContinent] || currentContinent) + ' ';
  }
  }
  function bindLocalCityClicks() {
  var toolbarEl = document.getElementById('joeba-az-toolbar');
  var toolbarH = toolbarEl ? toolbarEl.offsetHeight + 20 : 60;
  cityNavScroll.querySelectorAll('.joeba-city-nav__link').forEach(function(link) {
  link.addEventListener('click', function(e) {
  e.preventDefault();
  var cityHandle = this.getAttribute('data-nav-city');
  if (breadcrumbEl && cityHandle) breadcrumbEl.dataset.currentCityHandle = cityHandle;
  var target = document.querySelector('.joeba-blog-city[data-city-handle="' + cityHandle + '"]');
  if (target) {
  var y = target.getBoundingClientRect().top + window.pageYOffset - toolbarH - 10;
  window.scrollTo({ top: y, behavior: 'smooth' });
  }
  });
  });
  }
  })();
  (function() {
  var nav = document.getElementById('joeba-city-nav');
  if (!nav) return;
  var citySections = document.querySelectorAll('.joeba-blog-city');
  var navLinks = nav.querySelectorAll('.joeba-city-nav__link');
  var navScroll = document.getElementById('joebaCityNavScroll');
  var navLeft = document.getElementById('joebaCityNavLeft');
  var navRight = document.getElementById('joebaCityNavRight');
  var navScrollTop = document.getElementById('joebaCountryScrollTop');
  var firstSection = citySections[0];
  var toolbarEl = document.getElementById('joeba-az-toolbar');
  var toolbarH = toolbarEl ? toolbarEl.offsetHeight + 20 : 60;
  var scrollStep = 200;
  if (navLeft && navScroll) {
  navLeft.addEventListener('click', function() {
  navScroll.scrollBy({ left: -scrollStep, behavior: 'smooth' });
  });
  }
  if (navRight && navScroll) {
  navRight.addEventListener('click', function() {
  navScroll.scrollBy({ left: scrollStep, behavior: 'smooth' });
  });
  }
  if (navScrollTop) {
  navScrollTop.addEventListener('click', function() {
  var topEl = document.getElementById('joeba-blog-top');
  if (topEl) {
  topEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  });
  }
   nav.classList.add('is-visible');
  navLinks.forEach(function(link) {
  link.addEventListener('click', function(e) {
  e.preventDefault();
  var cityHandle = this.getAttribute('data-nav-city');
  var target = document.querySelector('.joeba-blog-city[data-city-handle="' + cityHandle + '"]');
  if (target) {
  var y = target.getBoundingClientRect().top + window.pageYOffset - toolbarH - 10;
  window.scrollTo({ top: y, behavior: 'smooth' });
  }
  });
  });
  })();
  (function() {
  var hash = window.location.hash;
  if (!hash || hash.length < 2) return;
  var cityHandle = hash.substring(1).replace(/^stad-/, '');
  var toolbarEl = document.getElementById('joeba-az-toolbar');
  var toolbarH = toolbarEl ? toolbarEl.offsetHeight + 20 : 60;
  var attempts = 0;
  var maxAttempts = 10;
  function tryScroll() {
  var target = document.querySelector('.joeba-blog-city[data-city-handle="' + cityHandle + '"]');
  if (target) {
  var y = target.getBoundingClientRect().top + window.pageYOffset - toolbarH - 10;
  window.scrollTo({ top: y, behavior: 'smooth' });
  var navLink = document.querySelector('.joeba-city-nav__link[data-nav-city="' + cityHandle + '"]');
  if (navLink) {
  document.querySelectorAll('.joeba-city-nav__link').forEach(function(l) { l.classList.remove('is-active'); });
  navLink.classList.add('is-active');
  navLink.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
  } else if (attempts < maxAttempts) {
  attempts++;
  setTimeout(tryScroll, 500);
  }
  }
  setTimeout(tryScroll, 1200);
  })();
